// @flow
/** @jsx h */

import { PureComponent } from '../../helpers/pure-components'
import { getFirebaseInstance } from '../../db/firebase'
import { extractActivePolls, preparePoll } from './helpers/pollUtils'
import type { Poll, AuthConfig } from '../../types'

type RenderProps = {
  poll?: Poll,
  error?: ?Error,
  loading: boolean
}

type Props = {
  clientId: number,
  authConfig: AuthConfig,
  render: (props: RenderProps) => any
}

type State = {
  poll?: Poll,
  error?: ?Error,
  loading: boolean
}

export class WithPollState extends PureComponent<Props, State> {
  state = {
    loading: false,
    poll: undefined,
    error: null
  }
  componentDidMount () {
    this.subscribeToPollChanges(this.props.clientId)
  }

  subscribeToPollChanges (clientId: number) {
    const { authConfig } = this.props
    try {
      getFirebaseInstance(authConfig)
        .database()
        .ref(`/channels/${clientId}/interactions`)
        .on('value', snapshot => {
          const firebaseInteractions = snapshot.val() || []
          const firebaseActivePolls = extractActivePolls(firebaseInteractions)
          if (!firebaseActivePolls.length) {
            this.setState({ error: null, poll: undefined, loading: false })
            return
          }
          // If there are more than one active poll, pick the first one
          const currentPoll = firebaseActivePolls[0]
          this.setState({
            poll: preparePoll(currentPoll),
            error: null,
            loading: false
          })
        })
    } catch (err) {
      const errorMessage = `Unable to find active polls for client ${clientId}`
      console.error(errorMessage)
      this.setState({ error: new Error(errorMessage) })
    }
  }

  render () {
    const { poll, error, loading } = this.state
    return this.props.render({ poll, error, loading })
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/WithPollState.js